import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import styled from 'styled-components';

export const StyledToastContainer = styled(ToastContainer)`
    margin-bottom: 60px;
    width: auto;
    .Toastify__toast {
        background-color: #373737;
        border-radius: 40px;
        color: white;
        border: 1px solid #ffffff;
        text-align: center;
        padding: 0 40px 0 40px;
    }
`

export const NotificationToastContainer = styled(ToastContainer)`
    .Toastify__toast {
        background: #373737;
        border-radius: 12px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(10px);
        font-size: 14px;
        font-weight: 500;
        color: white;
        text-align: left;
        padding: 16px 20px;
        word-wrap: normal;
        overflow-wrap: normal;
        word-break: keep-all;
    }
    .Toastify__close-button {
        color: #ffffff;
        opacity: 0.8;
    }
    .Toastify__progress-bar {
        background: rgba(255, 255, 255, 0.8);
    }
`

export const showNotificationToast = (message: string) => {
    toast.info(message, { containerId: "notification-container" });
};

export const NotificationToast = () =>
    <NotificationToastContainer
        containerId="notification-container"
        position="bottom-right"
        limit={3}
        autoClose={10000}
        closeButton={true}
        closeOnClick={true}
        pauseOnHover={true}
        hideProgressBar={false}
        draggable={true}
    />
;

const Toast = () =>
    <StyledToastContainer
        containerId="default-container"
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={10000}
        hideProgressBar
    />
;

export default Toast;